import React from 'react';
import {Flex, SVGButton} from '/app/src/component'
import {connect} from 'react-redux'
import style from './index.css'
import ConversationSelector from '/app/src/model/Conversation/selector';
import EmployeeSelector from '/app/src/model/Employee/selector';
import ConversationModel from '/app/src/model/Conversation/model'
import {Tags, H3} from '/app/src/component'

class AssignedTicketInfo extends React.Component {
    constructor(props) {
        super(props);
        this._handleTagDeletion = this._handleTagDeletion.bind(this);
        this._handleTagAddition = this._handleTagAddition.bind(this);
    // this._handleOnInputNote = this._handleOnInputNote.bind(this);
        this._craftDataOutput = this._craftDataOutput.bind(this);

        const dateCreated = new Date(ConversationSelector.getDateCreated(this.props.conversation));
        const datePretty = dateCreated.toLocaleDateString('sv');
        const conversation = this.props.conversation;

        this.state = {
            dateCreated: datePretty,
            // note: ConversationSelector.getNote(conversation),
            tags: ConversationSelector.getTags(conversation)
        };
    }

    componentWillReceiveProps(nextProps) {
        const conversation = nextProps.conversation;
        this.setState({
            tags: ConversationSelector.getTags(conversation)
            // note:  ConversationSelector.getNote(conversation)
        });
    }

    _handleTagAddition(tag) {
        const tags = this.state.tags;
        this.props.dispatch(ConversationModel.createTag(this.props.room, tag.text, tags));
    }

    //NOTE: Eventually use for ticket note.
    // _handleOnInputNote(e) {
    //     e.persist()
    //     this.setState((prevState) => {
    //         prevState[e.target.name] = e.target.value
    //         return prevState;
    //     });
    // }

    _handleTagDeletion(index) {
        const currentTags = this.state.tags;
        const room = this.props.room;
        this.props.dispatch(ConversationModel.deleteTag(room, currentTags, index));
    }

    _craftDataOutput(title, body) {
        return <Flex column marginTop='13px' color='black' w='50%'>
            <H3>{title}</H3>
            <h4 className={style.BodyText}>{body}</h4>
        </Flex>
    }

    render() {
        const ticketid = this.props.ticketid;
        const dateCreated = this.state.dateCreated;
        const tags = this.state.tags;

        const type = this.props.conversation.getIn(['meta', 'type'])

        return (
            <Flex w='100%' hAlignContent='center'>
                <Flex width='90%' column>
                    <Flex hAlignContent='left' width='100%' marginTop='20px'>
                        <H3> Ärende #{ticketid} </H3>
                        {type==='resolved' &&
                        <SVGButton
                            marginLeft='auto'
                            border
                            src='/images/Trash.svg'
                            color='black'
                            hover='red'
                            showConfirm={true}
                            confirmTitle='Tar bort konversation'
                            confirmContent={
                                <Flex center fontSize='22px' mb='12px' textAlign='center'>Är du säker på att du vill ta bort konversationen? Alllt meddelande i konversationen kommer att tas bort. Detta går inte att ångra</Flex>
                            }
                            confirmButton={{
                                'src': '/images/Trash.svg',
                                'text': 'Ta bort'
                            }}
                            onClick={() => this.props.deleteConversationFromDb(this.props.room)}
                            onCancel={()=>{}}
                        />
                        }
                        {/*<Flex vAlignContent='bottom' hAlignContent='right' basis='50%'>
                            <Flex hAlignContent='center' className={style.TicketInfoSaveButton} onClick={this._onTicketSaveInfo}> Spara </Flex>
                         </Flex>*/}
                    </Flex>
                    {/*<H3> Anteckningar </H3>*/}
                    {/*<TextInput value={this.state.notes} onChange={this._handleOnInputNote} placeholder='Anteckningar' name='notes'/>*/}
                    <H3>Tags</H3>
                    <Flex wrap width='100%'>
                        <Tags
                            tags={tags.toJS()}
                            handleDelete={this._handleTagDeletion}
                            handleAddition={this._handleTagAddition}
                            placeholder=' + Lägg till'
                            id='ticketTagInput'
                            allowDeleteFromEmptyInput={false}
                        />
                    </Flex>
                    <Flex column>
                        <Flex w='100%'>
                            {this._craftDataOutput('Ärendestatus', this.props.isResolved ? 'Avklarad' : 'Ej avklarad')}
                            {this._craftDataOutput('Senaste aktivitet', this.props.dateModified)}
                        </Flex>
                        <Flex w='100%'>
                            {this._craftDataOutput('Tilldelad medarbetare', this.props.assignedEmployeeName)}
                            {this._craftDataOutput('Skapad', dateCreated)}
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        )};
}

const {dispatcher: deleteConversationFromDb} = ConversationModel.deleteFromDB()

function mapStateToProps (state, props) {
    const conversation = ConversationSelector.getByRoom(state, props.room);
    const ticketid = ConversationSelector.getConversationId(conversation);
    const tags = ConversationSelector.getTags(conversation);
    const dateModified = new Date(ConversationSelector.getDateModified(conversation));
    const datePretty = dateModified.toLocaleDateString('sv');
    const type = ConversationSelector.isResolved(conversation);
    let isResolved = false;

    if(type === 'resolved'){
        isResolved = true;
    }
    const assignedEmployeeId = ConversationSelector.getAssignedEmployee(conversation);
    const employee = EmployeeSelector.getById(state, assignedEmployeeId);
    const name = EmployeeSelector.getEmployeeName(employee)
    return {
        conversation: conversation,
        tags: tags,
        ticketid: ticketid,
        dateModified: datePretty,
        isResolved: isResolved,
        assignedEmployeeName: name
    }
}

export default connect(mapStateToProps, {
    deleteConversationFromDb
})(AssignedTicketInfo);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/Conversation/Assigned/TicketInfo.js